// If Dropbox isn't on the webpage, then set this to null.
export const Dropbox = globalThis.Dropbox ? globalThis.Dropbox.Dropbox : undefined;
